import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  Typography,
} from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";

const CHUNK_SIZE = 5 * 1024 * 1024;

export default function UploadPdfDialog({
  open,
  onClose,
  podcastId,
  onSuccess,
  url,
}) {
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);

  const uploadFile = async (file) => {
    setUploading(true);
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const uploadId = `${Date.now()}-${file.name}`;

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append("chunk", chunk);
      formData.append("chunkIndex", chunkIndex);
      formData.append("totalChunks", totalChunks);
      formData.append("uploadId", uploadId);
      formData.append("fileName", file.name);

      // 👇 Send ID also
      formData.append("podcast_id", podcastId);

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}${url}`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
        },
      );

      const data = await response.json();

      if (!response.ok || data.success === false) {
        alert("Upload failed");
        setUploading(false);
        setProgress(0);
        onSuccess();
        return;
      }

      setProgress(Math.round(((chunkIndex + 1) / totalChunks) * 100));
    }

    toast.success("Upload Complete!");
    setUploading(false);
    setProgress(0);
    onSuccess();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Upload PDF</DialogTitle>

      <DialogContent>
        <Button variant="contained" component="label" disabled={uploading}>
          Select PDF
          <input
            hidden
            type="file"
            accept="application/pdf"
            onChange={(e) => uploadFile(e.target.files[0])}
          />
        </Button>

        {uploading && (
          <>
            <Typography sx={{ mt: 2 }}>Upload Progress: {progress}%</Typography>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{ mt: 1 }}
            />
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={uploading}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
